<template>
  <div class="app-credit-card-information summary-list">
    <div v-if="isSuccessful">
      <slot name="txtBefore"
        >Die Kreditkarte wurde geprüft &amp; erfolgreich gespeichert. Prozess fortsetzen mit "Weiter".</slot
      >

      <div class="summary-row">
        <div class="label">
          <slot name="lblCcHolder">Kreditkarteninhaber</slot>
        </div>
        <div class="value">{{ creditCardInformation.holder }}</div>
      </div>

      <div class="summary-row">
        <div class="label">
          <slot name="lblCcNumber">Kreditkartennummer</slot>
        </div>
        <div class="value">
          <span class="cc-number-block" :key="i" v-for="i in 3">****</span>
          <span class="cc-number-block">{{ creditCardInformation.lastDigits }}</span>
        </div>
      </div>

      <div class="summary-row">
        <div class="label">
          <slot name="lblCcType">Kartentyp</slot>
        </div>
        <div class="value">{{ creditCardInformation.company }}</div>
      </div>

      <div class="summary-row">
        <div class="label">
          <slot name="lblCcValidty">Gültigkeit</slot>
        </div>
        <div class="value">{{ formattedValidity }}</div>
      </div>

      <slot name="txtAfter"></slot>
    </div>
    <div v-else>
      <slot name="txtError">Es trat ein Fehler bei Prüfung der Kreditkarte auf</slot>
    </div>
  </div>
</template>

<script>
const leadingZeroFormatter = new Intl.NumberFormat('de-DE', {
  minimumIntegerDigits: 2,
  useGrouping: false
})

export default {
  name: 'ShowCreditCardInformation',
  computed: {
    isSuccessful: function() {
      return this.creditCardInformation !== null && this.creditCardInformation.registrationId !== null
    },
    formattedValidity: function() {
      const month = leadingZeroFormatter.format(this.creditCardInformation.expiryMonth)
      const year = leadingZeroFormatter.format(this.creditCardInformation.expiryYear)
      return `${year}-${month}`
    }
  },
  props: {
    creditCardInformation: {
      type: Object
    }
  }
}
</script>
